<template>
<div class="animated fadeIn dashboard">
  <!--
  <div class="card">
    <div class="card-body col-md-8">
      <h3>Dashboard</h3>
      <p><small>User - Dashboard</small></p>
    </div>
  </div>
-->
  <div class="col-md-8 pl-0">

    <template v-for="item in blog.root">
      <div class="card col-md-12">

        <article class="card-body blog-card col-md-12">
          <div class="row">

            <img :src="item.imgSrc" class="img-responsive" width="100%" height="auto" :alt="item.title" :title="item.title">



          </div>

          <div class="row">

            <h3 v-html="item.title"></h3>

            <p v-html="item.descriptionOut"></p>
            <br />

            <router-link :to="{ path: '/dashboard/dashboarddetails/'+item.blogId}" tag="button" class="btn btn-primary btn-sm" :alt="item.title" :title="item.title">
              {{$t('READMORE')}}
            </router-link>

            <hr class="hrfull">

            <div class='clear10'>&nbsp;</div>

          </div>

          <div class="autor-left">
            <div class="polje-slika">
              <img :src="item.avatarSrc" class="rounded-circle" width="40" height="40" alt="" title="" />
            </div>


            <p><span class="blog-author">{{item.author}}</span><br>
              <small>{{$t('PUBLISHEDON')}}: {{item.postDate}}</small><br>
              <!-- <small>{{item.commentCount}} {{$t('COMMENTS')}}</small> -->
            </p>

          </div>

        </article>

      </div>

    </template>

  </div>

  <div class="col-md-4 p-0">

    <aside class="card smaller">
      <div class="dash-field">
        <h3>{{$t('LATESTCONVERSATIONS')}}</h3>
      </div>
      <div class="dash-field-smaller">
        <template v-for="item in lastFiveBlogPosts.root">
          <div class="polje-dash">
            <div class="latest-conversations-main">
              <a :href="'#/dashboard/dashboarddetails/'+item.blogId">
              <div class="img-latest-conversations">
                <img :src="item.imgSrc" class="img-responsive" width="100%" height="auto" :alt="item.title" :title="item.title">
              </div>
                <div class="tekst-dash">
                  <h4 v-html="item.title"></h4>
                  <!--<p><small>{{item.username}} / {{item.postDate}}</small></p>-->
                </div>
              </a>
            </div>
            <template v-for="i in item.comments">
              <div class="comment-single-latest">
                <p class="latest-conversations-author">{{i.username}} | {{i.dateTime}}</p>
                <p><b v-html="i.comment"></b></p>
              </div>
            </template>
          </div>
          <hr>
        </template>
      </div>
    </aside>

  </div>

  <div class='clear10'>&nbsp;</div>
</div>
</template>

<script>
import BlogApi from '@/api/cms/Blog'
import DocumentsApi from '@/api/cms/Documents'

export default
{
  name: 'dashboard',
  data: function()
  {
    return {
      blog:
      {},
      lastFiveBlogPosts:
      {},
      lastFiveDocPosts:
      {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 25,
        searchTimeout: false
      }
    }
  },
  created()
  {
    var me = this;
    me.getBlog();
    me.getLastFiveBlogPosts();
  },
  methods:
  {
    async getBlog()
    {
      var me = this;
      try
      {
        var data = await BlogApi.selectRow(me.getParams);
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.blog = data;

        me.blabla = data.root[0].title;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getLastFiveBlogPosts()
    {
      var me = this;
      try
      {
        var data = await BlogApi.selectLastFivePosts();
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.lastFiveBlogPosts = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    }
  },
  watch:
  {

  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.pagination,
      {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
}
</script>
